/* eslint-disable */
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BaseHttpService, ResourceHelper } from '../util/http-services';
import { HttpClient } from '@angular/common/http';
import { EmptyMessage } from '../util/messages';
import { ClientDocumentResource } from '../client-document/client-document-resource.service';

/* eslint-enable */

@Injectable()
export class ColonnadeOnlineResourceService extends BaseHttpService {
  private static readonly baseUrl = '/client-document/';

  offerLogin(documentType: string, request: ColonnadeOnlineResource.ClientDocumentOfferLoginRequestResource): Observable<ClientDocumentResource.ClientDocument> {
    return this.http.post<ClientDocumentResource.ClientDocument>(this.url + `${documentType}/offer/login`, request);
  }

  offerAccept(documentType: string, request: ColonnadeOnlineResource.ClientDocumentOfferAcceptRequestResource): Observable<EmptyMessage> {
    return this.http.post<EmptyMessage>(this.url + `${documentType}/offer/accept`, request);
  }

  offerDecline(documentType: string, request: ColonnadeOnlineResource.ClientDocumentOfferLoginRequestResource): Observable<EmptyMessage> {
    return this.http.post<EmptyMessage>(this.url + `${documentType}/offer/decline`, request);
  }

  constructor(private http: HttpClient, resourceHelper: ResourceHelper) {
    super(resourceHelper, ColonnadeOnlineResourceService.baseUrl);
  }

}

export namespace ColonnadeOnlineResource {

  export interface ClientDocumentOfferLoginRequestResource {
    password: string;
    token: string;
  }

  export interface ClientDocumentOfferAcceptRequestResource extends ClientDocumentOfferLoginRequestResource {
    form?: ClientDocumentOfferConsentFormResource;
  }

  export interface ClientDocumentOfferConsentFormResource {
    personal_information_provided?: ClientDocumentOfferConsentResource;
    gathering_personal_information_approved?: ClientDocumentOfferConsentResource;
    marketing_research_approved?: ClientDocumentOfferConsentResource;
    home_insurance_interested?: ClientDocumentOfferConsentResource;
  }

  export interface ClientDocumentOfferConsentResource extends ClientDocumentResource.ObjectWithText {
  }

}
